import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { submitTag } from './tag-project-actions';
import styles from './tag-project.module.less';
import RoundedButtonSecondary from '../../../components/button/rounded-button-secondary/RoundedButtonSecondary';
import Dropdown from '../../../components/dropdown/Dropdown';
import { useProject } from '../../project-hooks/useProject';
import { isReceiverForProjectAnOrganization } from '../../project-model';
import { userIsMemberOfOrganization } from '../../../organization/authenticated-organization-helper';
import { useUser } from '../../../user/useUser';
import { hasSubscriptionFeatureOrProfile } from '../../../utils';

export const TagProject = () => {
    const project = useProject();
    const user = useUser();
    const dispatch = useDispatch();
    const [selectedTag, setSelectedTag] = useState(
        project?.profile?.availableOrganizationTags?.find((item) => project?.tags?.includes(item)) ?? ''
    );
    const [changed, setChanged] = useState(false);
    const stored = useSelector((state) => state.projects.storedTag);
    const error = useSelector((state) => state.projects.errorStoreTag);
    const availableTags = project?.profile?.availableOrganizationTags;

    if (
        !user ||
        !isReceiverForProjectAnOrganization(project) ||
        !userIsMemberOfOrganization({
            user,
            organizationId: project.receiver.id,
        }) ||
        !hasSubscriptionFeatureOrProfile({ project, name: 'tagProjects' }) ||
        !availableTags
    ) {
        return null;
    }

    const storeTag = () => {
        setChanged(false);
        dispatch(submitTag({ projectId: project.id, tag: selectedTag }));
    };

    function renderTagOptions() {
        return availableTags.map((t) => {
            const label = t.substring(t.indexOf('-') + 1);
            return (
                <option key={t} value={t} selected={t === selectedTag}>
                    {label}
                </option>
            );
        });
    }

    const disabled = stored && !changed;
    const showError = error && !changed;
    return (
        <div className={styles.tagContainer}>
            <Dropdown
                className={styles.select}
                onChange={(event) => {
                    setSelectedTag(event.target.value);
                    setChanged(true);
                }}
            >
                <option value={''}>Ikke på samleside</option>
                {renderTagOptions()}
            </Dropdown>
            <RoundedButtonSecondary
                disabled={disabled}
                onClick={storeTag}
                className={showError ? styles.errorButton : styles.button}
            >
                {disabled ? 'Lagret' : showError ? 'Feil' : 'Lagre'}
            </RoundedButtonSecondary>
        </div>
    );
};
